import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';

@Component({
  selector: 'app-modal-wrong-subscription',
  templateUrl: './modal-wrong-subscription.component.html',
  styleUrls: ['./modal-wrong-subscription.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalWrongSubscriptionComponent implements OnInit {

  @Input() isVisibleModal: boolean;
  @Output() subscribe: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit(): void {
  }

  onEmitSubscribe(): void {
    this.subscribe.emit();
  }
}
